import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Flex } from '@abyss/web/ui/Flex';
import { useTranslation } from 'react-i18next';

import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { RecommendationDetails } from '../../models/ProviderDetails';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { notXlScreenOnly, tabletScreen } from '../ConstantsStyles';
import {
  GroupedPinSmartChoiceScore,
  GroupedPinSmartChoiceScoreCardContainerListView,
  GroupedPinSmartChoiceScorePercentageListView,
  SmartChoiceScore,
  SmartChoiceScoreBox,
  SmartChoiceScoreBoxListView,
  SmartChoiceScoreBoxMapDatacard,
  SmartChoiceScoreBoxStackedGroupedPinDatacard,
  SmartChoiceScoreCardContainer,
  SmartChoiceScoreCardContainerListView,
  SmartChoiceScoreMapDatacard,
  SmartChoiceScorePercentageListView,
} from './SnackCard.styles';

const GroupedPinSmartChoiceScoreCardContainer = (
  notXlScreen,
  t,
  recommendationScore
) => (
  <SmartChoiceScoreCardContainer
    css={GroupedPinSmartChoiceScoreCardContainerListView}
  >
    <SmartChoiceScoreBox
      css={
        notXlScreen
          ? SmartChoiceScoreBoxStackedGroupedPinDatacard
          : SmartChoiceScoreBoxListView
      }
    >
      <GroupedPinSmartChoiceScore
        data-testid={`data-card-smart-choice-container`}
        size={'12px'}
      >
        {t('SMART_CHOICE.SMART_CHOICE')}

        <Flex
          css={
            notXlScreen
              ? SmartChoiceScoreMapDatacard
              : GroupedPinSmartChoiceScorePercentageListView
          }
        >
          {recommendationScore}%
        </Flex>
      </GroupedPinSmartChoiceScore>
    </SmartChoiceScoreBox>
  </SmartChoiceScoreCardContainer>
);

const getSmartChoiceScoreSize = (
  isDataCard: boolean,
  TabletScreen: boolean,
  expandedProviderListView: boolean
): string => {
  if (isDataCard && !expandedProviderListView) {
    return '11px';
  }
  if (isDataCard && expandedProviderListView && TabletScreen) {
    return '12px';
  }
  return '14px';
};

type Props = {
  recommendationDetails: RecommendationDetails | undefined;
  isDataCard?: boolean;
  expandedProviderListView?: boolean;
  isGroupedLocationDrawer?: boolean;
  isAlternativeDataCard?: boolean;
  isSnackCardOnTheMap?: boolean;
};
export const SmartChoiceScoreCard = ({
  recommendationDetails,
  isDataCard = false,
  expandedProviderListView = false,
  isGroupedLocationDrawer = false,
  isAlternativeDataCard = false,
  isSnackCardOnTheMap = false,
}: Props) => {
  const { t } = useTranslation();
  const recommendationScore =
    recommendationDetails?.totalRecommendationScore !== undefined
      ? recommendationDetails?.totalRecommendationScore
      : 0;

  const [enableMapViewHideOption] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_MAP_VIEW_HIDE_OPTION,
  ]);
  const notXlScreen = useMediaQuery(notXlScreenOnly);
  const TabletScreen = useMediaQuery(tabletScreen);
  return isGroupedLocationDrawer ? (
    GroupedPinSmartChoiceScoreCardContainer(notXlScreen, t, recommendationScore)
  ) : (
    <SmartChoiceScoreCardContainer
      css={SmartChoiceScoreCardContainerListView(
        isAlternativeDataCard,
        isDataCard,
        expandedProviderListView
      )}
    >
      <SmartChoiceScoreBox
        css={
          isGroupedLocationDrawer && notXlScreen
            ? SmartChoiceScoreBoxStackedGroupedPinDatacard
            : isDataCard && expandedProviderListView && enableMapViewHideOption
            ? SmartChoiceScoreBoxListView
            : isDataCard &&
              !expandedProviderListView &&
              enableMapViewHideOption &&
              !isSnackCardOnTheMap
            ? SmartChoiceScoreBoxMapDatacard
            : {}
        }
      >
        <SmartChoiceScore
          css={{
            paddingLeft:
              isDataCard &&
              !expandedProviderListView &&
              enableMapViewHideOption &&
              !isSnackCardOnTheMap
                ? '6px'
                : '0px',
          }}
          data-testid={`data-card-smart-choice-container`}
          size={getSmartChoiceScoreSize(
            isDataCard,
            TabletScreen,
            expandedProviderListView
          )}
        >
          {t('SMART_CHOICE.SMART_CHOICE')}
          {isDataCard && enableMapViewHideOption && !isSnackCardOnTheMap ? (
            <Flex
              css={
                isGroupedLocationDrawer && notXlScreen
                  ? SmartChoiceScoreMapDatacard
                  : SmartChoiceScorePercentageListView(expandedProviderListView)
              }
            >
              {recommendationScore}
              <span
                style={{
                  fontSize: '11px',
                }}
              >
                %
              </span>
            </Flex>
          ) : (
            ': ' + recommendationScore + '%'
          )}
        </SmartChoiceScore>
      </SmartChoiceScoreBox>
    </SmartChoiceScoreCardContainer>
  );
};
